"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscardOrderRatingNotification = void 0;
class DiscardOrderRatingNotification {
    constructor(orderRepository) {
        this.orderRepository = orderRepository;
    }
    execute(request) {
        return this.orderRepository.discardOrderRatingNotification(request);
    }
}
exports.DiscardOrderRatingNotification = DiscardOrderRatingNotification;
